import React from 'react';
import { css } from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { TableHeader, TableHeaderAlias } from './styled';
import { GenericCell, AliasCell, ActionsCell, CreatedCell, ExpiredCell } from './components/Cells';

/**
 * Access tokens table.
 * ctx: `{ tab, isFetching }`
 */
const accessTokensSchema = {
  id: 'accessTokens',
  loading: { mockRows: 8 },
  styles: css`
  .rt-table {
    .rt-thead, .rt-tbody {
      background: ${({ theme }) => theme.backgrounds.dashboard};
    }
  }
`,
  columns: [
    {
      header: () => <TableHeaderAlias> <FormattedMessage id="preferences.accessTokens.table.alias" /></TableHeaderAlias>,
      id: 'alias',
      resizable: true,
      sortable: false,
      maxWidth: 150,
      minWidth: 110,
      cell: (rowInfo, { isFetching }) => <AliasCell rowInfo={ rowInfo } isFetching={ isFetching } />
    },
    {
      header: () => <TableHeader> <FormattedMessage id="preferences.accessTokens.table.token" /></TableHeader>,
      id: 'token',
      resizable: false,
      sortable: false,
      maxWidth: 120,
      minWidth: 120,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo } isFetching={ isFetching } column="token" />
    },
    {
      header: () => <TableHeader> <FormattedMessage id="preferences.accessTokens.table.scope" /></TableHeader>,
      id: 'scope',
      resizable: true,
      sortable: false,
      maxWidth: 150,
      minWidth: 100,
      cell: (rowInfo, { isFetching }) => <GenericCell rowInfo={ rowInfo } isFetching={ isFetching } column="scope" />
    },
    {
      header: () => <TableHeader> <FormattedMessage id="preferences.accessTokens.table.created" /></TableHeader>,
      id: 'create_date',
      resizable: false,
      maxWidth: 100,
      minWidth: 100,
      cell: (rowInfo, { isFetching }) => <CreatedCell rowInfo={ rowInfo } isFetching={ isFetching } column="create_date" />
    },
    {
      header: () => <TableHeader> <FormattedMessage id="preferences.accessTokens.table.expires" /></TableHeader>,
      id: 'expires_at',
      resizable: false,
      sortable: false,
      maxWidth: 100,
      minWidth: 100,
      cell: (rowInfo, { isFetching }) => <ExpiredCell rowInfo={ rowInfo } isFetching={ isFetching } column="expires_at" />
    },
    {
      header: () => <TableHeader> <FormattedMessage id="preferences.accessTokens.table.actions" /></TableHeader>,
      id: 'actions',
      resizable: false,
      sortable: false,
      maxWidth: 87,
      minWidth: 87,
      cell: (rowInfo, { isFetching, tab }) => <ActionsCell rowInfo={ rowInfo } isFetching={ isFetching } tab={ tab } />
    }
  ]
};

export default accessTokensSchema;
